
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { iCodeModel } from '@/interface/exchange-code';
import { getCodeList, lockCode, getExcelTable } from '@/api/exchange-code';
import LogUtils from 'panda-log';
import ExchangePop from './exchange-code-create.vue';
import { toast } from '../../../utils/common';

@Component({
  components: { ExchangePop },
})
export default class ExchangeCode extends Mixins(PageQuery) {
  private visible = false;
  private loading = false;
  private tableData = [
    {
      id: 0,
      version: '',
      name: '',
      value: 0,
      total: 0,
      used: '',
      opt_user: '',
      first_user: 0,
      charge_user: 0,
      is_lock: 0,
    },
  ];

  private query: iCodeModel = {
    version: '',
    name: '',
    user: '',
  };

  get basicUrl() {
    return process.env.VUE_APP_BASE_API;
  }

  search() {
    this.page_query.page = 1;
    this.getCodeTable();
  }

  openModal() {
    this.visible = true;
  }

  async exportCodes(record: any) {
    try {
      let res = await getExcelTable({ cnt: record.total, version: record.version });
      let str = res as any;
      const link = document.createElement('a');
      const blob = new Blob([str], { type: 'text/plain' });
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      link.download = '兑换码' + record.version;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      LogUtils.debug(error);
    }
  }
  async getCodeTable() {
    try {
      this.loading = true;
      const res = await getCodeList({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async switchCode(record: any) {
    try {
      const res = await lockCode({ id: record.id, is_lock: record.is_lock });
      // toast((res as any).msg, 'success');
    } catch (error) {
      toast(error.msg, 'warning');
      LogUtils.debug(error);
    }
  }
  mounted() {
    this.pageFn = this.getCodeTable;
    this.getCodeTable();
  }
}
